/* eslint-disable no-prototype-builtins */
import { cookiesToZUID, cookiesToZGUID } from '@zillow/mortgage-urls';
import { event } from '@zillow/universal-analytics';

export function trackExposureEvent() {
    const campaignStates =
        window.optimizely && typeof window.optimizely.get === 'function'
            ? window.optimizely.get('state')
            : null;

    const campaigns =
        campaignStates && typeof campaignStates.getCampaignStates === 'function'
            ? campaignStates.getCampaignStates({ isActive: true })
            : null;

    if (campaigns && typeof campaigns === 'object') {
        // Build an array of active Optimizely treatments and their variation.
        const treatments = [];
        for (const key in campaigns) {
            const campaign = campaigns[key];
            // getCampaignStates with isActive: true returns only active campaigns by default
            if (
                campaign.hasOwnProperty('isInCampaignHoldback') &&
                campaign.isInCampaignHoldback === false &&
                campaign.hasOwnProperty('experiment') &&
                campaign.experiment &&
                campaign.experiment.hasOwnProperty('id') &&
                campaign.hasOwnProperty('variation') &&
                campaign.variation &&
                campaign.variation.hasOwnProperty('name') &&
                campaign.variation.hasOwnProperty('id')
            ) {
                let treatmentName = `OPTIMIZELY_${campaign.experiment.id}`;
                // If a variation name contains the word "control" (any case), we will use CONTROL as the variation name.
                const variationName = campaign.variation.name;
                if (variationName?.toLowerCase().includes('control')) {
                    treatmentName = treatmentName + '.CONTROL';
                } else {
                    treatmentName =
                        treatmentName + '.V_' + campaign.variation.id;
                }
                treatments.push(treatmentName);
            }
        }
        // Set randomizationKey to the ZUID if exists, or a GUID if not.
        let keyType = 'zuid';
        let randomizationKey = cookiesToZUID(document.cookie);
        if (
            typeof randomizationKey !== 'string' ||
            randomizationKey.toLowerCase() === 'null'
        ) {
            keyType = 'guid';
            randomizationKey = cookiesToZGUID(document.cookie);
        }
        // Track exposure events if treatments exist and randomizationKey is set.
        if (
            typeof randomizationKey === 'string' &&
            randomizationKey.toLowerCase() !== 'null' &&
            treatments.length > 0
        ) {
            // https://dataportal.zillowgroup.net/event-registry/5485
            event({
                envelope: {
                    event_type_id: '5485',
                    event_type_version_id: '1',
                    event_template_id: '3',
                    event_template_version_id: '1',
                },
                semantic: {
                    semantic_event_nm: 'optimizely_exposure',
                    topic_tag_txt: ['cms', 'optimizely'],
                },
                exposure: {
                    assignment_service_cd: 'optimizely',
                    key_type_cd: keyType,
                    randomization_key: randomizationKey,
                    treatment_nm: treatments,
                },
            });
        }
    }
}
